<div class="categories-list">
  <ng-container
    *ngIf="{
      count: count$ | async,
      categories: categories$ | async
    } as obs"
  >
    <div *ngIf="(isLoading$ | async) !== true || obs.categories?.length; else showLoader">
      <gb-items-observer
        *ngIf="obs.categories"
        [nthItemToObserve]="5"
        [stalePages$]="stalePages$"
        (onFocusEvent)="onFocus($event)"
        (onScrollEvent)="onScroll($event)"
      >
        <gb-infinite-scroll (scrolled)="onEndReached(obs.count, obs.categories)">
          <ng-container *ngFor="let category of obs.categories | gbOrderBy: 'order,label'; trackBy: trackCategory">
            <gb-category-preview [category]="category" id="{{ category.uuid }}" #item> </gb-category-preview>
          </ng-container>
        </gb-infinite-scroll>
      </gb-items-observer>
    </div>

    <ng-container *ngIf="(isLoading$ | async) && isMoreCategoriesToLoad(obs.count, obs.categories)">
      <ng-template [ngTemplateOutlet]="showLoader"></ng-template>
    </ng-container>

    <ng-template #showLoader>
      <div class="loader-container flex-row flex-justify-center flex-align-center">
        <gb-loading-spinner [showLoader]="isLoading$" [label]="'CATEGORIES.LOADING_CATEGORIES'"> </gb-loading-spinner>
      </div>
    </ng-template>
  </ng-container>
</div>
